import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeLayoutComponent } from './layouts/home-layout.component';
import { LoginGuard } from './home/auth/login.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './home/login/login.component';
import { ForgotPasswordComponent } from './home/forgot-password/forgot-password.component';
import { SetupAccountComponent } from './home/setup-account/setup-account.component';
import { RouteConstants } from './share/constants/routes.constants';
import { AddProductComponent } from './order-details/add-product/add-product.component';
import { ProductListComponent } from './order-details/product-list/product-list.component';
import { OrderOutComponent } from './order-details/order-out/order-out.component';
import { OrderListComponent } from './order-details/order-list/order-list.component';
import { AddMasterDataComponent } from './master-data-details/add-master-data/add-master-data.component';
import { MasterDataListComponent } from './master-data-details/master-data-list/master-data-list.component';
import { VehicleModelComponent } from './master-data-details/vehicle-model/vehicle-model/vehicle-model.component';
import { VehicleMakeComponent } from './master-data-details/vehicle-make/vehicle-make/vehicle-make.component';
import { VehicleMakeListComponent } from './master-data-details/vehicle-make-list/vehicle-make-list.component';
import { VehicleModelListComponent } from './master-data-details/vehicle-model-list/vehicle-model-list.component';
import { DealerDetailsComponent } from './dealer-details/add-dealer/dealer-details.component';
import { DealersListComponent } from './dealer-details/dealers-list/dealers-list.component';
import { TyreBrandComponent } from './master-data-details/tyre-brand/tyre-brand.component';
import { TyreBrandListComponent } from './master-data-details/tyre-brand-list/tyre-brand-list.component';
import { TyreModelComponent } from './master-data-details/tyre-model/tyre-model.component';
import { TyreModelListComponent } from './master-data-details/tyre-model-list/tyre-model-list.component';
import { RegisterComponent } from './home/register/register.component';
import { StockTransferToBranchComponent } from './order-details/stock-transfer-to-branch/stock-transfer-to-branch.component';
import { ReturnToDealerComponent } from './returns/return-to-dealer/return-to-dealer.component';
import { ReturnFromCustomerComponent } from './returns/return-from-customer/return-from-customer.component';
import { ReturnAndReplaceComponent } from './returns/return-and-replace/return-and-replace.component';
import { ServiceEntryComponent } from './order-details/service-entry/service-entry/service-entry.component';
import { ServiceListComponent } from './order-details/service-entry/service-list/service-list.component';
import { ViewImportStockListComponent } from './master-data-details/view-import-stock-list/view-import-stock-list.component';
import { SaleDealerComponent } from './order-details/sale-dealer/sale-dealer.component';
import { MasterDataComponent } from './master-data-details/master-data/master-data.component';
import { PendingTyrePatternComponent } from './master-data-details/pending-tyre-pattern/pending-tyre-pattern.component';
import { SkuLedgerComponent } from './ledgers/sku-ledger/sku-ledger.component';
import { PaymentAccountComponent } from './master-data-details/payment-account/payment-account.component';
import { DayBookComponent } from './day-book/day-book.component';
import { ExpenseCategoriesComponent } from './master-data-details/expense-categories/expense-categories.component';
import { ExpensesComponent } from './expenses/expenses.component';
import { SkuMergeComponent } from './sku-merge/sku-merge.component';
import { BalanceAccountComponent } from './master-data-details/balance-account/balance-account.component';
import { SettlementsComponent } from './settlements/settlements.component';

const routes: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: RouteConstants.LrTemplateGeneration,
        loadChildren: () =>
          import('./lr-templates/lr-templates.module').then(
            (m) => m.LrTemplatesModule
          ),
      },
      {
        path: RouteConstants.Package,
        loadChildren: () =>
          import('./packages/packages.module').then((m) => m.PackagesModule),
      },
      {
        path: 'new-product',
        component: AddProductComponent,
      },
      {
        path: 'product-list',
        component: ProductListComponent,
      },
      {
        path: 'new-dealer',
        component: DealerDetailsComponent,
      },
      {
        path: 'dealer-list',
        component: DealersListComponent,
      },
      {
        path: 'order-out',
        component: OrderOutComponent,
      },
      {
        path: 'order-list',
        component: OrderListComponent,
      },
      {
        path: 'add-master-data',
        component: AddMasterDataComponent,
      },
      {
        path: 'master-data-list',
        component: MasterDataListComponent,
      },
      {
        path: 'vehicle-model',
        component: VehicleModelComponent,
      },
      {
        path: 'vehicle-make',
        component: VehicleMakeComponent,
      },
      {
        path: 'vehicle-make-list',
        component: VehicleMakeListComponent,
      },
      {
        path: 'vehicle-model-list',
        component: VehicleModelListComponent,
      },
      {
        path: 'tyre-brand',
        component: TyreBrandComponent,
      },
      {
        path: 'tyre-brand-list',
        component: TyreBrandListComponent,
      },
      {
        path: 'tyre-model',
        component: TyreModelComponent,
      },
      {
        path: 'tyre-model-list',
        component: TyreModelListComponent,
      },
      {
        path: 'transfer-to-branch',
        component: StockTransferToBranchComponent,
      },
      {
        path: 'return-to-dealer',
        component: ReturnToDealerComponent,
      },
      {
        path: 'return-from-customer',
        component: ReturnFromCustomerComponent,
      },
      {
        path: 'return-and-replace',
        component: ReturnAndReplaceComponent,
      },
      {
        path: 'service-entry',
        component: ServiceEntryComponent,
      },
      {
        path: 'service-list',
        component: ServiceListComponent,
      },
      {
        path:'view-import-stock-list',
        component: ViewImportStockListComponent,
      },
      {
        path:'sale-to-dealer',
        component: SaleDealerComponent
      },
      {
        path:'master-data',
        component: MasterDataComponent
      },
      {
        path:'pending-tyre-pattern',
        component: PendingTyrePatternComponent
      },
      {
        path:'sku-ledger',
        component: SkuLedgerComponent
      },
      {
        path: 'payments-account',
        component: PaymentAccountComponent
      },
      {
        path: 'day-book',
        component: DayBookComponent
      },
      {
        path: 'expense-categories',
        component: ExpenseCategoriesComponent
      },
      {
        path: 'expenses',
        component: ExpensesComponent
      },
      {
        path: 'sku-merge',
        component: SkuMergeComponent
      },
      {
        path: 'balance-account',
        component: BalanceAccountComponent
      },
      {
        path: 'settlements',
        component: SettlementsComponent
      }
    ],
  },
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'setup-account',
        component: SetupAccountComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
